import { type GetApiStatisticsQueryParams } from '@/shared/api'
import dayjs, { type Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { type DayjsRange } from './types/common'

dayjs.extend(utc)

const getUtcOffsetString = (date: Dayjs): string => {
  const offsetMinutes = date.utcOffset()
  const sign = offsetMinutes >= 0 ? '%2B' : '-'
  const absOffset = Math.abs(offsetMinutes)
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${sign}${pad(Math.floor(absOffset / 60))}:${pad(absOffset % 60)}`
}

const toApiDateString = (date: Dayjs, hour: number, minute: number): string => {
  const localDate = date
    .set('hour', hour)
    .set('minute', minute)
    .set('second', 0)
    .set('millisecond', 0)
  const offsetStr = getUtcOffsetString(localDate)
  return `${localDate.format('YYYY-MM-DDTHH:mm')}${offsetStr}`
}
export const convertDayjsRangeToApiFormat = (
  range: DayjsRange,
): GetApiStatisticsQueryParams => {
  if (!range.start || !range.end || range.allTime)
    return {
      StartDate: undefined,
      EndDate: undefined,
      GetForAllTime: true,
    }

  return {
    StartDate: toApiDateString(range.start, 0, 0),
    EndDate: toApiDateString(range.end, 23, 59),
    GetForAllTime: false,
  }
}
